
import XHeader from 'vux/src/components/x-header/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import PopupRadio from 'vux/src/components/popup-radio/index.vue'
import Datetime from 'vux/src/components/datetime/index.vue'
import PopupPicker from 'vux/src/components/popup-picker/index.vue'
import Checker from 'vux/src/components/checker/checker.vue'
import CheckerItem from 'vux/src/components/checker/checker-item.vue'
import Cell from 'vux/src/components/cell/index.vue'
import dateFormat from 'vux/src/tools/date/format.js'

import vuescroll from 'vuescroll'
import { mapState, mapActions } from 'vuex'
export default {
name: 'info',
props: [],
components: {
'scroller': vuescroll,
XHeader,
XInput,
Group,
XButton,
PopupRadio,
Datetime,
PopupPicker,
Checker,
CheckerItem,
Cell
},
data () {
return {
ops: {
scrollPanel: {
scrollingX: false
},
bar: {
background: 'rgba(0, 107, 178, 0.3)',
size: '3px',
opacity: 0
}
},
isProfession: false,
isClass: false,
professionText: '请选择您的专业',
classText: '请选择您的班级',
studentInfo: {
name: this.$store.state.userInfo.name,
account: this.$store.state.userInfo.account,
sno: this.$store.state.userInfo.sno,
idNumber: this.$store.state.userInfo.idNumber,
cardId: this.$store.state.userInfo.cardId,
cardAccount: this.$store.state.userInfo.cardAccount,
examNumber: this.$store.state.userInfo.examNumber,
sex: this.$store.state.userInfo.sex,
birthdate: this.$store.state.userInfo.birthdate,
countryCode: [this.$store.state.userInfo.countryCode],
nationCode: [this.$store.state.userInfo.nationCode],
politicsStatusCode: [this.$store.state.userInfo.politicsStatusCode],
identityCode: [this.$store.state.userInfo.identityCode],
campusCode: [this.$store.state.userInfo.campusCode],
campusName: this.$store.state.userInfo.campusName,
grade: String(this.$store.state.userInfo.grade),
academyCode: [this.$store.state.userInfo.academyCode],
academyName: this.$store.state.userInfo.academyName,
departmentCode: [this.$store.state.userInfo.departmentCode],
departmentName: this.$store.state.userInfo.departmentName,
professionCode: [this.$store.state.userInfo.professionCode],
professionName: this.$store.state.userInfo.professionName,
classCode: [this.$store.state.userInfo.classCode],
className: this.$store.state.userInfo.className,
originCode: [],
origin: this.$store.state.userInfo.origin,
phoneNumber: this.$store.state.userInfo.phoneNumber,
email: this.$store.state.userInfo.email,
qq: this.$store.state.userInfo.qq,
wechat: this.$store.state.userInfo.wechat
},
showInfoArr: [],
value: [],
grade: [],
country: [],
nation: [],
politicsStatus: [],
identity: [],
campus: [],
academy: [],
department: [],
profession: [],
classes: [],
origin: [],
fromItem: {
baseFeildList: [],
extendFeildList: [],
studentExtendFeildList: [],
baseValueList: [],
extendValueList: []
},
today: dateFormat(new Date(), 'YYYY-MM-DD'),
year: dateFormat(new Date(), 'YYYY'),
extendInfo: [],
departmentDetail: []
}
},
computed: {
...mapState({
userInfo: state => state.userInfo,
flowId: state => state.flowInfo.flowId,
flowProcedureId: state => state.currentProcedureInfo.flowProcedureId,
procedureId: state => state.currentProcedureInfo.procedureId
}),
title () {
return this.$route.meta.title
}
},
created () {
this.getStudent()
this.getExtendInfo()
this.getInfoList()
this.getCountry()
this.getNation()
this.getIdentity()
this.getPoliticsStatus()
this.getCampus()
this.getAcademy()
this.getDepartment()
this.getProfession(this.studentInfo.departmentCode[0])
this.getClass(this.studentInfo.departmentCode[0], this.studentInfo.professionCode[0])
},
mounted () {

let originCode = []
this.getArea().then(() => {
let newArr = []
let arr = this.studentInfo.origin ? this.studentInfo.origin.split(' ') : []
let originLen = this.origin.length
for (var i = 0; i < originLen; i++) {
for (var j = 0; j < arr.length; j++) {
if (this.origin[i].name === arr[j]) {
newArr.push(this.origin[i])
}
}
}

newArr.sort(this.compare('grade'))
newArr.forEach(element => {
originCode.push(element.value)
})
this.studentInfo.originCode = originCode
})
},
updated () {},
destroyed () {},
watch: {},
methods: {
...mapActions(['userInfoAction']),

compare (property) {
return function (a, b) {
var value1 = a[property]
var value2 = b[property]
return value1 - value2
}
},
back () {
setTimeout(() => {
this.$router.back(-1)
}, 300)
},
getStudent () {
let params = {
account: this.userInfo.account
}
this.$api.get('/student', params, r => {
let data = r.data[0]
this.$store.dispatch('userInfoAction', data)
})
},
getExtendInfo () {
let params = {
tableName: 'V_USER_STUDENT',
resourceId: this.userInfo.id
}
this.$api.get('/extendInfo', params, r => {
this.extendInfo = r.data
})
},

getInfoList () {
this.$vux.loading.show()
let params = {
flowId: this.flowId,
flowProcedureId: this.flowProcedureId,
procedureId: this.procedureId
}
this.$api.get('/studentInfo/config', params,
r => {
this.$vux.loading.hide()
let data = r.data
this.showInfoArr = data.baseFeildList
this.fromItem.extendFeildList = data.extendFeildList
this.fromItem.studentExtendFeildList = data.studentExtendFeildList

let extendLen = this.extendInfo.length

this.fromItem.studentExtendFeildList.forEach(element => {
if (extendLen === 0) {
this.$set(element, 'value', '')
} else {

for (var i = 0; i < extendLen; i++) {
if (element.name === this.extendInfo[i].tableField) {
this.$set(element, 'value', this.extendInfo[i].value)
}
}
}
})
},
err => {
this.$vux.toast.text(err.message, 'top')
})
},
getName (value) {

},
changeIdentity (value) {
this.studentInfo.professionCode = []
this.studentInfo.classCode = []
this.studentInfo.professionName = []
this.studentInfo.className = []
this.getProfession(this.studentInfo.departmentCode[0])
this.getClass(this.studentInfo.departmentCode[0], null)
},
changeCampus (value) {
this.studentInfo.campusName = this.$refs.campus.getNameValues()
},
changeAcademy (value) {
this.studentInfo.academyName = this.$refs.academy.getNameValues()
},
changeDepartment (value) {
this.studentInfo.departmentName = this.$refs.department.getNameValues()
let departmentCode = value[0]
this.studentInfo.professionCode = []
this.studentInfo.classCode = []
this.studentInfo.professionName = []
this.studentInfo.className = []
this.getProfession(departmentCode)
this.getClass(departmentCode, null)
},
changeProfession (value) {
this.studentInfo.professionName = this.$refs.profession.getNameValues()
let professionCode = value[0]
this.studentInfo.classCode = []
this.studentInfo.className = []
this.getClass(this.studentInfo.departmentCode[0], professionCode)
},
changeClass (value) {
this.studentInfo.className = this.$refs.classes.getNameValues()
},
changeOrigin (value) {
this.studentInfo.origin = this.$refs.origin.getNameValues()
},

getCountry () {
this.$api.get('/country', null,
r => {
let data = r.data
let arr = []
data.forEach((element, i) => {
let obj = {
name: element.name,
value: element.code
}
arr.push(obj)
})
this.country.push(arr)
},
err => {
this.$vux.toast.text(err.message, 'top')
})
},

getNation () {
this.$api.get('/nation', null,
r => {
let data = r.data
let arr = []
data.forEach((element, i) => {
let obj = {
name: element.name,
value: element.code
}
arr.push(obj)
})
this.nation.push(arr)
},
err => {
this.$vux.toast.text(err.message, 'top')
})
},

getPoliticsStatus () {
this.$api.get('/politicsStatus', null,
r => {
let data = r.data
let arr = []
data.forEach((element, i) => {
let obj = {
name: element.name,
value: element.code
}
arr.push(obj)
})
this.politicsStatus.push(arr)
},
err => {
this.$vux.toast.text(err.message, 'top')
})
},

getIdentity () {
this.$api.get('identity', null,
r => {
let data = r.data
let arr = []
data.forEach((element, i) => {
let obj = {
name: element.name,
value: element.code
}
arr.push(obj)
})
this.identity.push(arr)
},
err => {
this.$vux.toast.text(err.message, 'top')
})
},

getArea () {
return new Promise((resolve, reject) => {
this.$api.get('area', null,
r => {
let data = r.data
data.forEach((element, index) => {
if (element.grade !== 1) {
let obj = {
name: element.name,
value: String(element.code),
grade: element.grade
}
if (element.grade === 2) {
obj.parent = 0
} else if (element.grade > 2 && element.grade <= 4) {
obj.parent = String(element.parentCode)
}
this.origin.push(obj)
}
})
resolve()
},
err => {
this.$vux.toast.text(err.message, 'top')
})
})
},

getCampus () {
this.$api.get('campus', null,
r => {
let data = r.data
let arr = []
data.forEach((element, i) => {
let obj = {
name: element.name,
value: element.code
}
arr.push(obj)
})
this.campus.push(arr)
},
err => {
this.$vux.toast.text(err.message, 'top')
})
},

getAcademy () {
let params = {
type: 2
}
this.$api.get('department', params,
r => {
let data = r.data
let arr = []
data.forEach((element, i) => {
let obj = {
name: element.name,
value: element.code
}
arr.push(obj)
})
this.academy.push(arr)
},
err => {
this.$vux.toast.text(err.message, 'top')
})
},

getDepartment () {
let params = {
type: 1
}
this.$api.get('department', params,
r => {
let data = r.data

let arr = []
data.forEach((element, i) => {
let obj = {
name: element.name,
value: element.code,
parent: 0
}
arr.push(obj)
})
this.department.push(arr)
},
err => {
this.$vux.toast.text(err.message, 'top')
})
},

getProfession (code) {
let params = {
departmentCode: code,
identityCode: this.studentInfo.identityCode[0]
}
this.$api.get('profession', params,
r => {
let data = r.data
if (data.length > 0) {
this.isProfession = false
this.professionText = '请选择您的专业'
let arr = []
data.forEach((element, i) => {
let obj = {
name: element.name,
value: element.code,
parent: element.departmentCode
}
arr.push(obj)
})
this.profession = []
this.profession.push(arr)
} else {
this.professionText = '暂无专业'
this.isProfession = true
this.studentInfo.professionCode = []
this.studentInfo.professionName = []
}
},
err => {
this.$vux.toast.text(err.message, 'top')
})
},

getClass (departmentCode, professionCode) {
let params = {
departmentCode: departmentCode,
professionCode: professionCode
}
this.$api.get('class', params,
r => {
let data = r.data
if (data.length > 0) {
this.isClasss = false
this.classText = '请选择您的班级'
let arr = []
data.forEach((element, i) => {
let obj = {
name: element.name,
value: element.code
}
arr.push(obj)
})
this.classes = []
this.classes.push(arr)
} else {
this.isClass = true
this.classes = []
this.studentInfo.classCode = []
this.studentInfo.className = []
this.classText = '暂无班级'
}
},
err => {
this.$vux.toast.text(err.message, 'top')
})
},

checkWechat (value) {
var reg = /^([-_a-zA-Z0-9]{5,19})+$/
if (reg.test(value)) {
return {valid: true}
} else {
return {valid: false, msg: '微信格式错误'}
}
},

checkTel (value) {
var reg = /^([0-9]{3,4}-)?[0-9]{7,8}$/
if (reg.test(value)) {
return {valid: true}
} else {
return {valid: false, msg: '联系电话格式错误'}
}
},
save () {
let errorLength = document.getElementsByClassName('weui-cell weui-cell_warn').length
let defaultObj = {
id: this.userInfo.id,
flowId: this.flowId,
flowProcedureId: this.flowProcedureId,
procedureId: this.procedureId
}

let baseObj = {}


this.showInfoArr.forEach(element => {
let obj = {}
if (typeof this.studentInfo[element] === 'object') {

obj[element] = this.studentInfo[element] === null ? '' : this.studentInfo[element][0]
} else {
obj[element] = this.studentInfo[element]
}
let objName = {}
if (element === 'academyCode') {
objName = {
academyName: this.studentInfo['academyName']
}
} else if (element === 'departmentCode') {
objName = {
departmentName: this.studentInfo['departmentName']
}
} else if (element === 'professionCode') {
objName = {
professionName: this.studentInfo['professionName']
}
} else if (element === 'classCode') {
objName = {
className: this.studentInfo['className']
}
} else if (element === 'campusCode') {
objName = {
campusName: this.studentInfo['campusName']
}
}
baseObj = Object.assign(baseObj, obj, objName)
})


let extendObj = {}
let extendInfo = []
this.fromItem.studentExtendFeildList.forEach(element => {
for (var i = 0; i < this.fromItem.extendFeildList.length; i++) {
let obj = {}
if (element.name === this.fromItem.extendFeildList[i]) {
obj['code'] = element.name
obj['value'] = element.value
extendInfo.push(obj)
}
}
})
let isSubmit = false
let valueArr = []

for (var j in baseObj) {
valueArr.push(baseObj[j])
}
for (var i in extendInfo) {
valueArr.push(extendInfo[i].value)
}

if (valueArr.indexOf('') === -1) {
isSubmit = true
}
extendObj['extendInfo'] = JSON.stringify(extendInfo)
let params = Object.assign(defaultObj, baseObj, extendObj)
if (errorLength === 0 && isSubmit) {
this.$vux.loading.show()
this.$api.post('/studentInfo', params,
r => {
this.$vux.loading.hide()
this.$vux.toast.show({
text: '提交成功',
position: 'middle',
time: 1000
})
this.$parent.getStudent()
this.$parent.getExtendInfo()
this.$parent.getFlowProcedureStatus()

setTimeout(() => {
this.back()
}, 1000)
},
err => {
this.$vux.toast.text(err.message, 'top')
})
} else {
this.$vux.toast.text('请填写完整的信息', 'middle')
}
}
}
}



// WEBPACK FOOTER //
// ./src/yingxin/tskjxy/views/items/info/personalInfo.vue